import React, { useEffect, useState } from 'react';
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { notify } from '../toast';

const MONTHS = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const fmt = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

const AdminPayouts = () => {
    const axiosPrivate = useAxiosPrivate();

    const [failed, setFailed] = useState([]);
    const [paying, setPaying] = useState({});

    useEffect(() => {
        fetchFailed();
        // eslint-disable-next-line
    }, []);

    const fetchFailed = async () => {
        try {
            const res = await axiosPrivate.get('/payout/failed');
            setFailed(res.data || []);
        } catch (err) {
            notify('failed', err?.response?.data?.message || err?.message || 'Error fetching failed payouts');
        }
    };

    const manualPay = async (recordId, employeeName) => {
        try {
            setPaying(p => ({ ...p, [recordId]: true }));
            const res = await axiosPrivate.post(`/payout/manualPay/${recordId}`, {
                note: 'Manually paid by admin'
            });
            notify('success', `${employeeName}: ${res.data.message}`);
            fetchFailed();
        } catch (err) {
            notify('failed', err?.response?.data?.message || err?.message || 'Error approving the manual payout');
        }
    };

    return (
        <div className="container">
            <h2 style={{ textAlign: 'center', margin: '20px 0', color: 'var(--secondary-text-color)' }}>
                Salary Payout Management
            </h2>

            {failed.length > 0 ? (
                <div style={styles.box}>
                    <section className="user-list">
                        <div className="list-header">
                            <span>Employee</span>
                            <span>Hierarchy</span>
                            <span>Period</span>
                            <span>Amount</span>
                            <span>Reason</span>
                            <span>Action</span>
                        </div>
                        <div className="list-body">
                            {failed.map(r => (
                                <div className="list-row" key={r._id}>
                                    <span data-label="Employee">{r.employee?.name}</span>
                                    <span data-label="Level">{r.employee?.role?.replace('_', ' ')}</span>
                                    <span data-label="Period">{r.period === 'first_half' ? '1st mid' : '2nd mid'} {MONTHS[r.month]} {r.year}</span>
                                    <span data-label="Amount">{fmt(r.totalAmount)}</span>
                                    <span data-label="Reason" style={{ fontSize: '.8rem', color: '#b91c1c' }}>
                                        {r.status || 'Unknown'}
                                    </span>
                                    <span>
                                        <button
                                            className="approve-btn"
                                            disabled={paying[r._id]}
                                            onClick={() => manualPay(r._id, r.employee?.name)}
                                        >
                                            {paying[r._id] ? <span className="spinner" /> : 'Pay Now'}
                                        </button>
                                    </span>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            )
                :
                <p><i>No failed payouts</i></p>}
        </div>
    );
};

const styles = {
    box: {
        borderRadius: 12,
        padding: '16px 20px',
        marginBottom: 20,
        width: '100%',
    },
    selectorRow: {
        display: 'flex',
        // gap: 10,
        flexWrap: 'wrap',
        alignItems: 'center',
        marginBottom: 20,
        width: '70%',
        margin: '0 auto 20px',
    },
    cardLabel: { fontSize: '.75rem', color: '#888', marginBottom: 4 },
    cardValue: { fontSize: '1.3rem', fontWeight: 700 },
    statusBadge: {
        borderRadius: 20,
        padding: '2px 9px',
        fontSize: '.72rem',
        fontWeight: 600,
    },
};

export default AdminPayouts;
